import dayjs from 'dayjs';

export const getMeetingStatus = (calendarMeeting) => {
    if (!calendarMeeting) {
        return {
            started: false,
            ended: false,
            status: 'Before the meeting'
        };
    }

    let started = false;
    let ended = false;

    if (calendarMeeting.start_date) {
        let startDateTime = dayjs(calendarMeeting.start_date).format('YYYY-MM-DD');

        if (calendarMeeting.start_time) {
            startDateTime += ' ' + dayjs(calendarMeeting.start_time).format('HH:mm');
        }

        started = dayjs(startDateTime).isSameOrBefore(dayjs());
    }

    if (calendarMeeting.end_date) {
        let endDateTime = dayjs(calendarMeeting.end_date).format('YYYY-MM-DD');

        if (calendarMeeting.end_time) {
            endDateTime += ' ' + dayjs(calendarMeeting.end_time).format('HH:mm');
            ended = dayjs(endDateTime).isBefore(dayjs().startOf('minute'));
        } else {
            const isSameDay = dayjs(calendarMeeting.end_date).isSame(dayjs(), 'day');
            ended = !isSameDay && dayjs(endDateTime).isBefore(dayjs());
        }
    }

    let status;

    if (!started) {
        status = 'Before the meeting';
    } else if (ended) {
        status = 'After the meeting';
    } else {
        status = 'During the meeting';
    }

    return {
        started,
        ended,
        status
    };
};
